import {
    createStore,
    applyMiddleware,
    compose
} from 'redux';
import ReduxThunk from 'redux-thunk';
import reducers from './reducers';
import securityMiddleware  from '../components/common/security/security.middleware';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers,  composeEnhancers(applyMiddleware(ReduxThunk, securityMiddleware)));

export default store;
